<template>
  <div>
    <el-card class="box-card" body-style="min-height:60vh;">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="分类筛选：" prop="region">
            <el-select v-model="searchForm.region" placeholder="请选择" class="mt-search-width">
              <el-option label="全部" value="0"></el-option>
              <el-option v-for="(item,index) in cateList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类名称：" prop="name">
            <el-input v-model="searchForm.name" placeholder="分类名称搜索" class="mt-search-width"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button @click="toAdd('')" size="small" type="primary" class="bg-theme">添加分类</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList"
          row-key="id"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="name"
            label="分类名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="icon"
            label="图标">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.icon != '' && scope.row.icon != null"
                style="width: 88px;"
                :src="scope.row.icon"
                :preview-src-list="[scope.row.icon]"
                fit="contain"></el-image>
              <span v-if="scope.row.icon == '' || scope.row.icon == null">--</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1" class="mt-green">开启</span>
              <span v-else class="mt-red">禁用</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateTime"
            label="更新时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="toAdd(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <el-dialog
      title="添加分类"
      :visible.sync="dialogVisible"
      width="960px">
      <el-form :model="cateForm" :rules="cateRules" label-width="140px">
        <el-form-item label="父级：" prop="parentId">
          <el-select style="width: 420px;" v-model="cateForm.parentId" placeholder="请选择">
            <el-option label="顶级分类" value="0"></el-option>
            <el-option v-for="(item,index) in cateList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称：" prop="name">
          <el-input style="width: 420px;" v-model="cateForm.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="图片：" :prop="cateForm.parentId == 0 ? '' : 'icon'">
          <el-upload
            :action="baseUrl+'/system/common/upload/uploadFile'"
            list-type="picture-card"
            :headers="{'Authorization': token}"
            :multiple="false"
            :limit="1"
            :file-list="dialogVisible ? fileList : []"
            :on-remove="delImgBtn"
            :on-success="uploadImgBtn">
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">建议尺寸：96*96px，若需要更换图片，请先删除原图片</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="是否开启：" prop="status">
          <el-switch
            v-model="cateForm.status"
            active-color="#1890FF"
            inactive-color="#CCCCCC">
          </el-switch>
        </el-form-item>
        <el-form-item label="排序：" prop="sort">
          <el-input style="width: 420px;" v-model="cateForm.sort" placeholder="请输入排序(默认1)"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { goodsCateList, goodsCateDel, goodsCateFirstParentList,goodsCateAdd,goodsCateEdit,goodsCateInfo } from '@/api/goodsCate'
export default {
  name: 'Goods_cate',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      baseUrl:this.$baseUrl,
      token:this.$token,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:'',
        region:''
      },
      // 一级分类数据
      dataId:'',
      cateList:[],
      dialogVisible: false,
      cateForm:{
        parentId:'0',
        name:'',
        icon:'',
        status:true,
        sort:''
      },
      cateRules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '请选择图片', trigger: 'blur' }
        ]
      },
      fileList:[]
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    this.firstCateFun()
    this.getInfoList()
  },
  methods: {
    /* 上传图片 */
    uploadImgBtn(file){
      this.cateForm.icon = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(file,fileList){
      var icon = '';
      fileList.forEach(function(item){
        icon = item.url;
      });
      this.cateForm.icon = icon;
    },
    // 获取一级分类数据
    firstCateFun(){
      let that = this
      goodsCateFirstParentList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.cateList = data
        }
        if (res.errorCode === '4002') {
          that.cateList = []
        }
      })
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let parentId = that.searchForm.region === 0 ? '' : that.searchForm.region
      let enableParentId = (parentId == '' || parentId == 0) ? 0 : 1
      let page = that.currentPage
      goodsCateList({ name: searchName,parentId:parentId,enableParentId:enableParentId,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        goodsCateDel({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    /* 跳转添加 */
    toAdd (dataId) {
      this.dataId = dataId
      this.cateForm.parentId = '';
      this.cateForm.name = '';
      this.cateForm.icon = '';
      this.fileList = [];
      this.cateForm.sort = '';
      if(dataId != ''){
        let that = this
        goodsCateInfo({ id: dataId }).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            that.cateForm.parentId = (data.parentId == null || data.parentId == '') ? '0' : data.parentId
            that.cateForm.name = data.name
            that.cateForm.icon = data.icon
            if(data.icon != '' && data.icon != null){
              that.fileList = [{url: data.icon}]
            }
            that.cateForm.status = data.status == 1 ? true : false
            that.cateForm.sort = data.sort
          }
        })
      }
      this.dialogVisible = true
    },
    // 添加-编辑
    saveBtn(){
      var that = this
      var dataId = that.dataId
      var parentId = that.cateForm.parentId == 0 || that.cateForm.parentId == null ? '' : that.cateForm.parentId
      var name = that.cateForm.name
      var icon = that.cateForm.icon
      var status = that.cateForm.status ? 1 : 0
      var sort = that.cateForm.sort == '' ? 1 : that.cateForm.sort
      if (name === '') {
        this.$message.error('请输入分类名称')
        return false
      }
      if (icon === '' && parentId != 0) {
        this.$message.error('请上传图片')
        return false
      }
      let passData = {
        parentId: parentId,name: name, icon: icon, status: status, sort: sort
      }
      if (dataId !== '') {
        passData = {
          id: dataId, parentId: parentId,name: name, icon: icon, status: status, sort: sort
        }
        goodsCateEdit(passData).then((res) => {
          that.fullscreenLoading = false;
          if(res.errorCode == "0000"){
            that.cateForm.parentId = '';
            that.cateForm.name = '';
            that.cateForm.icon = '';
            that.fileList = [];
            that.cateForm.sort = '';
            that.dialogVisible=false;
            that.firstCateFun()
            that.currentPage = 1;
            that.getInfoList();
          }
          if(res.errorCode == "1001"){
            that.$message.error(res.msg);
          }
        })
      }else{
        goodsCateAdd(passData).then((res) => {
          that.fullscreenLoading = false;
          if(res.errorCode == "0000"){
            that.cateForm.parentId = '';
            that.cateForm.name = '';
            that.cateForm.icon = '';
            that.fileList = [];
            that.cateForm.sort = '';
            that.dialogVisible=false;
            that.firstCateFun()
            that.currentPage = 1;
            that.getInfoList();
          }
          if(res.errorCode == "1001"){
            that.$message.error(res.msg);
          }
        })
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/Cate.vue